import { execute as executeDiscourageDisabledFields } from './discourage-disabled-fields';
import { execute as executeFormElementType } from './form-element-type';
import { execute as executeNoDynamicData } from './no-dynamic-data';
import { execute as executeNoEmptyLists } from './no-empty-lists';
import { execute as executeNoNestedComponentKey } from './no-nested-component-key';
import { execute as executeNoValidationType } from './no-validation-type';
import { execute as executeNoConditionalField } from './no-conditional-field';
import { execute as executeNoTextExpression } from './feel/no-text-expression';
import { execute as executeNoTextTemplate } from './feel/no-text-template';
import { execute as executeNoDecimalNumbers } from './no-decimal-number';
import { execute as executeNoSearchableSelect } from './no-searchable-select';
import { execute as executeNoPrefixSuffix } from './no-prefix-suffix';
import { execute as executeNoVersionTag } from './no-version-tag';
import { execute as executeNoVerticalAlignment } from './no-vertical-alignment';
import { execute as executeNoRowLayout } from './no-row-layout';
import { execute as executeNoRequiredValidation } from './no-required-validation';
import { execute as executeNoReadonly } from './no-readonly';
import { execute as executeNoSubmitButton } from './no-submit-button';
import { execute as executeValidateFeel } from './feel/validate-feel';
import { execute as executeNoLabelExpression } from './feel/no-label-expression';
import { execute as executeNotDescriptionExpression } from './feel/no-description-expression';
import { execute as executeNoLabelTemplate } from './feel/no-label-template';
import { execute as executeNotDescriptionTemplate } from './feel/no-description-template';
import { execute as executeNoImageTemplates } from './feel/no-image-templates';
import { execute as executeNoPrefixSuffixTemplates } from './feel/no-prefix-suffix-templates';
import { execute as executeNoSecurityAttributes } from './no-security-attributes';
import { execute as executeNoPrefixSuffixExpressions } from './feel/no-prefix-suffix-expressions';
import { execute as executeNoValidationExpressions } from './feel/no-validation-expressions';
import { execute as executeNoValuesExpression } from './feel/no-values-expression';

export const defaultRuleRegistry = {
  'discourage-disabled-fields': executeDiscourageDisabledFields,
  'form-element-type': executeFormElementType,
  'no-conditional-field': executeNoConditionalField,
  'no-dynamic-data': executeNoDynamicData,
  'no-empty-lists': executeNoEmptyLists,
  'no-nested-component-key': executeNoNestedComponentKey,
  'no-text-expression': executeNoTextExpression,
  'no-text-template': executeNoTextTemplate,
  'no-validation-type': executeNoValidationType,
  'no-decimal-number': executeNoDecimalNumbers,
  'no-searchable-select': executeNoSearchableSelect,
  'no-prefix-suffix': executeNoPrefixSuffix,
  'no-row-layout': executeNoRowLayout,
  'no-required-validation': executeNoRequiredValidation,
  'validate-feel': executeValidateFeel,
  'no-readonly': executeNoReadonly,
  'no-label-expression': executeNoLabelExpression,
  'no-description-expression': executeNotDescriptionExpression,
  'no-label-template': executeNoLabelTemplate,
  'no-description-template': executeNotDescriptionTemplate,
  'no-image-templates': executeNoImageTemplates,
  'no-prefix-suffix-templates': executeNoPrefixSuffixTemplates,
  'no-prefix-suffix-expressions': executeNoPrefixSuffixExpressions,
  'no-validation-expressions': executeNoValidationExpressions,
  'no-values-expression': executeNoValuesExpression,
  'no-version-tag': executeNoVersionTag,
  'no-vertical-alignment': executeNoVerticalAlignment,
  'no-security-attributes': executeNoSecurityAttributes,
  'no-submit-button': executeNoSubmitButton
};